module.exports = __webpack_public_path__ + "static/media/curves_gris_claro.b7532e09.jpg";